import {
    Alert,
    Badge,
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Spinner
} from "reactstrap";
import {useHistory, useParams} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import {firebaseConstants, getDb} from "../../util/Constants";
import {collection, doc, getDoc, getDocs, query, updateDoc, where} from "firebase/firestore";

export default function EditLevel(props) {
    const [data, setData] = useState(null);
    const [previousLevelName, setPreviousLevelName] = useState("0");
    const [difficulties, setDifficulties] = useState([])
    const [levelName, setLevelName] = useState("0");
    const [passingScore, setPassingScore] = useState(100);
    const [time, setTime] = useState(100);
    const [isFinal, setIsFinal] = useState(false);
    const [difficulty, setDifficulty] = useState("easy");
    const [tQuestions, setTQuestions] = useState([1, 1, 1]);
    const [minAttempts, setMinAttempts] = useState([1, 1, 1]);
    const [level, setLevel] = useState(1);
    const [goalText, setGoalText] = useState("");
    const [levelDifficultyScores, setLevelDifficultyScores] = useState({});
    const [loading, setLoading] = useState('data');
    const [evaluation, setEvaluation] = useState("");
    const [questionsNumbers, setQuestionsNumbers] = useState("");
    const [gameName, setGameName] = useState("Edit Level");
    const [id, setId] = useState()
    const initialRender = useRef(true);

    const history = useHistory();
    const {lName} = useParams();
    const {eventId} = useParams();

    const db = getDb();
    const utilRef = collection(db, firebaseConstants.dbUtil);
    const levelDifficultyScoresRef = collection(db, firebaseConstants.dbDifficulties);


    useEffect(async () => {

        try {
            levelDifficulties().then(data => {
                setLevelDifficultyScores(data || {easy: 250, medium: 375, hard: 500});
            });

            await getLevel();
            setLoading(null);
        } catch (e) {
            setData(null);
            setLoading(null);
        }

    }, []);


    const getLevel = async () => {
        const q = query(collection(db, "Levels"), where("tabName", "==", lName), where("eventId", "==", eventId));

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            const _level = doc.data()
            setId(doc.id)
            setLevelName(lName);
            setPreviousLevelName(lName);
            setIsFinal(_level['Final'] === 'y');
            setPassingScore(_level['passingScore']);
            setGameName(_level["name"]);
            setTime(_level['time']);
            setDifficulty(_level["difficulty"] ?? "Easy");
            setTQuestions(_level['totalQuestion'].split("|"));
            setMinAttempts(_level['minAttempt'].split("|"));
            // setLevel(isLevel ? 1 : _level['totalQuestion'].split("=")[1]);
            setGoalText(_level['goalText']);
            setPassingScore(_level['passingScore']);
            setEvaluation(_level["evaluation"]);
            setQuestionsNumbers(_level["nbrOfQues"]);

            setData(_level);
        });
    }


    useEffect(() => {

        const attempts = minAttempts.reduce((a, b) => Number(a) + Number(b), 0);


        if (initialRender.current) {
            initialRender.current = false;
        } else {
            if (!levelName.startsWith('Mini')) {

                setPassingScore(attempts * levelDifficultyScores[difficulty]);
            }
        }
    }, [difficulty]);
    // levelDifficultyScoresminAttempts,
    const getMetaData = async () => {
        let data = {};
        const docRef = doc(utilRef, 'meta');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            data = docSnap.data();
        }
        return data;
    }

    const levelDifficulties = async () => {
        const querySnapshot = await getDocs(collection(getDb(), "levelDifficultyScores"));
        let dataArr = []
        querySnapshot.forEach((doc) => {
            dataArr.push(
                {
                    difficulty: doc.data().difficulty,
                    passingScore: doc.data().passingScore,
                    id: doc.id

                }
            )
        })
        setDifficulties(dataArr)
        const myObject = {};

        for (let i = 0; i < dataArr.length; i++) {
            const item = dataArr[i];
            myObject[item.difficulty] = item.passingScore;
        }
        return myObject
    }


    const handleSubmit = async e => {
        setLoading('saving');
        e.preventDefault();

        const docRef = doc(db, "Levels", id);

        await updateDoc(docRef, {
            totalQuestion: tQuestions.join("|"),
            minAttempt: minAttempts.join("|"),
            time: time,
            difficulty: difficulty,
            goalText: goalText,
            passingScore: passingScore,
            evaluation: evaluation,
            nbrOfQues: Number(questionsNumbers),
        });

        history.push(`/admin/levels/${eventId}`);
    }
    // _data['totalQuestion'] = Number.isInteger(Number(levelName)) ? tQuestions.join("|") : `L=${level}`;
    // _data['Min Attempt'] = Number.isInteger(Number(levelName)) ? minAttempts.join("|") : '';
    const detailsPage = () => {

        history.push(`/admin/levelDetails/${eventId}/${lName}`)
    }


    return (
        <>
            <Container fluid>
                <Row className="mb-4">
                    <Col>
                        <Card className="shadow">
                            <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                                <h2 className="mb-0">{gameName || 'Edit Level'}</h2>
                                {isFinal && <h2 className="mb-0"><Badge color="primary">Final Level</Badge></h2>}
                            </CardHeader>
                            <CardBody>
                                {
                                    loading === 'data' ?
                                        <div className="text-center py-5">
                                            <Spinner color="primary"/>
                                        </div> :
                                        data ?
                                            <Form onSubmit={handleSubmit}>
                                                <Row>
                                                    {/* <Col lg={3}>
                                                        <FormGroup>
                                                            <Label for="tabName">Level Name</Label>
                                                            <Input type="select" name="Tab Name" id="tabName"
                                                                value={levelName}
                                                                className="form-control-alternative" required
                                                                onChange={e => {
                                                                    setLevelName(e.target.value);
                                                                }}
                                                            >
                                                                {
                                                                    levelNames
                                                                        .filter(_levelName => Number.isInteger(Number(previousLevelName)) ? Number.isInteger(Number(_levelName)) : !Number.isInteger(Number(_levelName)))
                                                                        .map(_levelName =>
                                                                            <option>{_levelName}</option>)
                                                                }
                                                            </Input>
                                                        </FormGroup>
                                                    </Col> */}
                                                    <Col lg={3}>
                                                        <FormGroup>
                                                            <Label for="passingScore">Passing Score</Label>
                                                            <Input type="number" id="passingScore"
                                                                   value={passingScore || ""}
                                                                   required
                                                                   maxLength={4}
                                                                   onInput={object => {

                                                                       if (object.target.value.length > object.target.maxLength)
                                                                           object.target.value = object.target.value.slice(0, object.target.maxLength)
                                                                   }}
                                                                   placeholder="0" className="form-control-alternative"
                                                                   onChange={e => setPassingScore(e.target.value)}/>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg={3}>
                                                        <FormGroup>
                                                            <Label for="time">Time (in seconds)</Label>
                                                            <Input
                                                                type="number"
                                                                id="time"
                                                                value={time}
                                                                required
                                                                maxLength={4}
                                                                // onInput={(e) =>
                                                                //     setTime(e.target.value)}
                                                                className="form-control-alternative"
                                                                onChange={(e) => setTime(e.target.value)}
                                                            />
                                                        </FormGroup>
                                                    </Col>

                                                    <Col lg={3}>
                                                        {Number.isInteger(Number(levelName)) ?
                                                            <FormGroup>
                                                                <Label for="difficulty">Difficulty Level</Label>
                                                                <Input
                                                                    type="select"
                                                                    required
                                                                    id="difficulty"
                                                                    value={difficulty}
                                                                    className="form-control-alternative"
                                                                    onChange={(e) =>
                                                                        setDifficulty(e.target.value)
                                                                    }
                                                                >
                                                                    {difficulties?.map((e) => (
                                                                        <option
                                                                            value={e.difficulty}>{e.difficulty}</option>

                                                                    ))}

                                                                </Input>
                                                            </FormGroup> :
                                                            <FormGroup>
                                                                <Label for="level">Number of Questions</Label>
                                                                <Input
                                                                    type="number"
                                                                    id="level"
                                                                    value={questionsNumbers}
                                                                    maxLength={2}
                                                                    onInput={(object) => {
                                                                        if (
                                                                            object.target.value.length >
                                                                            object.target.maxLength
                                                                        )
                                                                            object.target.value = object.target.value.slice(
                                                                                0,
                                                                                object.target.maxLength
                                                                            );
                                                                    }}
                                                                    onChange={(e) =>
                                                                        setQuestionsNumbers(e.target.value)
                                                                    }
                                                                    className="form-control-alternative"
                                                                    required
                                                                />
                                                            </FormGroup>
                                                        }
                                                    </Col>
                                                    <Col lg={6}>
                                                        <FormGroup>
                                                            <Label for="goalText">Level Objective</Label>
                                                            <Input type="textarea" name="Goal_text" id="goalText"
                                                                   maxLength="300"
                                                                   rows={10}
                                                                   value={goalText}
                                                                   onChange={e => setGoalText(e.target.value)}
                                                                   className="form-control-alternative"/>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg={6}>
                                                        {
                                                            Number.isInteger(Number(levelName)) &&
                                                            <>
                                                                <FormGroup>
                                                                    <Label>Total Questions</Label>
                                                                    <Row>
                                                                        <Col lg={4}>
                                                                            <p className="mb-0 small">Questions</p>
                                                                            <Input type="number" name="questions"
                                                                                   value={tQuestions[0]} required
                                                                                   maxLength={2}
                                                                                   onInput={object => {
                                                                                       if (object.target.value.length > object.target.maxLength)
                                                                                           object.target.value = object.target.value.slice(0, object.target.maxLength)
                                                                                   }}
                                                                                   className="form-control-alternative"
                                                                                   onChange={e => setTQuestions([e.target.value, tQuestions[1], tQuestions[2]])}/>
                                                                        </Col>
                                                                        <Col lg={4}>
                                                                            <p className="mb-0 small">Emails</p>
                                                                            <Input type="number" name="emails"
                                                                                   value={tQuestions[1]} required
                                                                                   maxLength={2}
                                                                                   onInput={object => {
                                                                                       if (object.target.value.length > object.target.maxLength)
                                                                                           object.target.value = object.target.value.slice(0, object.target.maxLength)
                                                                                   }}
                                                                                   className="form-control-alternative"
                                                                                   onChange={e => setTQuestions([tQuestions[0], e.target.value, tQuestions[2]])}/>
                                                                        </Col>
                                                                        <Col lg={4}>
                                                                            <p className="mb-0 small">SMS</p>
                                                                            <Input type="number" name="sms"
                                                                                   value={tQuestions[2]} required
                                                                                   maxLength={2}
                                                                                   onInput={object => {
                                                                                       if (object.target.value.length > object.target.maxLength)
                                                                                           object.target.value = object.target.value.slice(0, object.target.maxLength)
                                                                                   }}
                                                                                   className="form-control-alternative"
                                                                                   onChange={e => setTQuestions([tQuestions[0], tQuestions[1], e.target.value])}/>
                                                                        </Col>
                                                                    </Row>
                                                                </FormGroup>
                                                                <FormGroup>
                                                                    <Label>Minimum Attempts</Label>
                                                                    <Row>
                                                                        <Col lg={4}>
                                                                            <p className="mb-0 small">Questions</p>
                                                                            <Input type="number" name="questions"
                                                                                   value={minAttempts[0]} required
                                                                                   maxLength={2}
                                                                                   onInput={object => {
                                                                                       if (object.target.value.length > object.target.maxLength)
                                                                                           object.target.value = object.target.value.slice(0, object.target.maxLength)
                                                                                   }}
                                                                                   className="form-control-alternative"
                                                                                   onChange={e => setMinAttempts([e.target.value, minAttempts[1], minAttempts[2]])}/>
                                                                        </Col>
                                                                        <Col lg={4}>
                                                                            <p className="mb-0 small">Emails</p>
                                                                            <Input type="number" name="emails"
                                                                                   value={minAttempts[1]} required
                                                                                   maxLength={2}
                                                                                   onInput={object => {
                                                                                       if (object.target.value.length > object.target.maxLength)
                                                                                           object.target.value = object.target.value.slice(0, object.target.maxLength)
                                                                                   }}
                                                                                   className="form-control-alternative"
                                                                                   onChange={e => setMinAttempts([minAttempts[0], [e.target.value], minAttempts[2]])}/>
                                                                        </Col>
                                                                        <Col lg={4}>
                                                                            <p className="mb-0 small">SMS</p>
                                                                            <Input type="number" name="sms"
                                                                                   value={minAttempts[2]} required
                                                                                   maxLength={2}
                                                                                   onInput={object => {
                                                                                       if (object.target.value.length > object.target.maxLength)
                                                                                           object.target.value = object.target.value.slice(0, object.target.maxLength)
                                                                                   }}
                                                                                   className="form-control-alternative"
                                                                                   onChange={e => setMinAttempts([minAttempts[0], minAttempts[1], [e.target.value]])}/>
                                                                        </Col>
                                                                    </Row>
                                                                </FormGroup>
                                                            </>
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg={12}>

                                                        <div className="d-flex justify-content-between">
                                                            <div>
                                                                <Button color="primary" onClick={detailsPage}
                                                                >Details</Button>
                                                            </div>
                                                            <div>

                                                                <Button
                                                                    color="danger"
                                                                    onClick={() => history.goBack()}
                                                                >
                                                                    Cancel
                                                                </Button>
                                                                <Button
                                                                    color="primary"
                                                                    type="submit"
                                                                    disabled={loading === 'saving'}
                                                                >
                                                                    {
                                                                        loading === 'saving' ?
                                                                            <Spinner color="light" size="sm"/> :
                                                                            'Save'
                                                                    }
                                                                </Button>
                                                            </div>

                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form> :
                                            <div className="text-center">
                                                <Alert color="danger">
                                                    Something went wrong while loading data, try refreshing the page.
                                                </Alert>
                                            </div>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
